import { useEffect, useState } from 'react'
import { Button, Callout, DatePicker, FieldRow, FormSection, Icon, Paragraph, StackList, StackListItem, toastError } from 'admination-react'
import { formatDatum } from '@/core/lib/dates'
import { friendlyErrorMessage } from '@/core/lib/dbError'
import { getUnterrichtsfrei, unterrichtsfreiEntfernen, unterrichtsfreiHinzufuegen } from '../../api/anwesenheit'

const SPEICHER_FEHLER = 'Die Änderung konnte nicht gespeichert werden.'

export function UnterrichtsfreiTage({ massnahmeId, isOwner }: { massnahmeId: string; isOwner: boolean }) {
  const [tage, setTage] = useState<string[] | null>(null)
  const [ladeFehler, setLadeFehler] = useState(false)
  const [neu, setNeu] = useState('')
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    let abgebrochen = false
    setTage(null)
    setLadeFehler(false)
    getUnterrichtsfrei(massnahmeId)
      .then((geladen) => { if (!abgebrochen) setTage(geladen) })
      .catch((error: unknown) => {
        console.error('getUnterrichtsfrei() failed:', error)
        if (!abgebrochen) setLadeFehler(true)
      })
    return () => { abgebrochen = true }
  }, [massnahmeId])

  const aendern = async (schreiben: () => Promise<void>, naechste: (aktuell: string[]) => string[]) => {
    setBusy(true)
    try {
      await schreiben()
      setTage((aktuell) => naechste(aktuell ?? []))
      setNeu('')
    } catch (error) {
      console.error('Tage ohne Unterricht speichern fehlgeschlagen:', error)
      toastError(friendlyErrorMessage(error, SPEICHER_FEHLER))
    } finally {
      setBusy(false)
    }
  }

  return <FormSection label="Tage ohne Unterricht">
    {ladeFehler && <Callout tone="error" role="alert" title="Die Tage ohne Unterricht konnten nicht geladen werden." />}
    {tage && tage.length === 0 && <Paragraph>Keine Tage ohne Unterricht eingetragen.</Paragraph>}
    {tage && tage.length > 0 && <StackList aria-label="Tage ohne Unterricht">
      {tage.map((tag) => <StackListItem key={tag} end={isOwner && (
        <Button iconOnly aria-label={`${formatDatum(tag)} entfernen`} title={`${formatDatum(tag)} entfernen`} disabled={busy}
          onClick={() => void aendern(() => unterrichtsfreiEntfernen(massnahmeId, tag), (aktuell) => aktuell.filter((d) => d !== tag))}>
          <Icon name="i-trash" />
        </Button>
      )}>{formatDatum(tag)}</StackListItem>)}
    </StackList>}
    {isOwner && tage && <FieldRow>
      <DatePicker aria-label="Tag ohne Unterricht" value={neu} onChange={setNeu} pastYears={1} />
      <Button disabled={!neu || busy || tage.includes(neu)} loading={busy}
        onClick={() => void aendern(() => unterrichtsfreiHinzufuegen(massnahmeId, neu), (aktuell) => [...aktuell, neu].sort())}>
        <Icon name="i-plus" />Hinzufügen
      </Button>
    </FieldRow>}
  </FormSection>
}
